import { render, staticRenderFns } from "./editPerm.vue?vue&type=template&id=440966ad&scoped=true&"
import script from "./editPerm.vue?vue&type=script&lang=js&"
export * from "./editPerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440966ad",
  null
  
)

export default component.exports